import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { User } from "../../user/user.model";
import { NotifyService } from "../../notify/notify.service";
import { eventType } from "../../notify/event.const";
import { containClassInElementTree } from "../../shared/html/contain-class-in-element-tree.function";
import { NavigationStart, Router, RouterLink } from "@angular/router";
import { ToggleSwitch } from "primeng/toggleswitch";
import { Subscription } from "rxjs";
import { EventService } from "../../shared/event/event.service";
import { role } from "../../user/role.const";
import { filter } from "rxjs/operators";
import { NgxPermissionsModule } from "ngx-permissions";
import { NotificationDropdownComponent } from "../notification-dropdown/notification-dropdown.component";
import { UserMenuComponent } from "../user-menu/user-menu.component";
import { NavComponent } from "../nav/nav.component";
import { SupportService } from "../support/support.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    RouterLink,
    ToggleSwitch,
    NgxPermissionsModule,
    NotificationDropdownComponent,
    UserMenuComponent,
    NavComponent,
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private notifyService = inject(NotifyService);
  private eventService = inject(EventService);
  private router = inject(Router);
  private supportService = inject(SupportService);

  @Input() public user: User;
  public subscription = new Subscription();
  public navVisible = false;
  public userGuideOn = false;
  public role = role;
  public readonly helpdeskUrl = "https://quotiss.groovehq.com/help_center";

  ngOnInit() {
    this.subscribeToRouter();
    this.observeLogoUrlChanges();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener("document: mousedown", ["$event"]) onMouseDown(event) {
    if (containClassInElementTree(event.target, "navbar-toggle")) {
      this.toggleNav();
    }

    if (
      !containClassInElementTree(event.target, "navbar-toggle") &&
      !containClassInElementTree(event.target, "toggle-submenu") &&
      !containClassInElementTree(event.target, "submenu-item") &&
      !!this.navVisible
    ) {
      this.navVisible = false;
    }
  }

  public emitUserProgressToggle() {
    this.eventService.eventBus.emit({
      event: eventType.userProgressToggle,
    });
  }

  public openSupport() {
    this.supportService.open();
  }

  public toggleNav() {
    this.navVisible = !this.navVisible;
  }

  private subscribeToRouter() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (this.navVisible) {
          this.navVisible = false;
        }
      });
  }

  private observeLogoUrlChanges() {
    this.subscription.add(
      this.eventService.eventBus.subscribe((incoming) => {
        if (incoming.event === eventType.organizationLogoChanged) {
          this.user
            ?.getTeam()
            ?.getOrganization()
            ?.getLogo()
            ?.setPath(incoming.data);
        }
      }),
    );
  }
}
